import o from "../services/ApiService.js";
import { showErrorMessage as i } from "../utils/notifiers.js";
import { useSelector as c } from "react-redux";
const P = () => {
  const { user: t } = c((e) => e.app.datastate), n = (e) => ({
    patientId: e.id,
    ownerUserId: t._id,
    // Using the user._id from the state
    patientName: e.name,
    age: e.age,
    gender: e.gender
  });
  return { savePatient: async (e) => {
    const s = [n(e)];
    try {
      const { status: a, data: r } = await o(t.userToken).PostPatients({
        patients: s,
        ownerUserId: t._id
      });
      return a.toString().match(/^4/) && i(r.message ?? "Failed to add new patients. Please try again later"), r;
    } catch (a) {
      console.log("error", a);
    }
  } };
};
export {
  P as default
};
